import { Typography } from "PFComponents/typography";
import { utc } from "PFCore/helpers/date";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";

type DateAttributeProps = {
  value: string;
};

export const DateAttribute = ({ value }: DateAttributeProps) => {
  const { formatDateTime } = useDateFormatter();
  return (
    <Typography withMargin variant="bodyRegular" tag="span">
      {formatDateTime(utc(value))}
    </Typography>
  );
};
